module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-chart"
  }, _vm._l((_vm.types), function(type) {
    return _c('chart', {
      key: type.code,
      attrs: {
        "name": type.name,
        "code": type.code
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36b0477c","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChartGroup.vue
// module id = eORg
// module chunks = 2